import { useState } from 'react';
import './CardWithModal.css'

export default function CardWithModal({ details }) {
    // State to manage modal visibility
    const [showModal, setShowModal] = useState(false);
    const [imageSrc, setImageSrc] = useState('');

    // Function to open the modal and set the full image
    const openModal = (src) => {
        setImageSrc(src);
        setShowModal(true);
    };

    // Function to close the modal
    const closeModal = () => {
        setShowModal(false);
        setImageSrc('');
    };
    return (
        <div className="container card-main">
            <div className="card">
                <img src={details.src} className="card-img-top" alt={details.altText} onClick={() => openModal(`${details.src}`)} />
                <div className="card-body">
                    <p className="card-text">{details.title}</p>
                </div>
            </div>

            {/* Bootstrap Modal for full image */}
            <div className={`modal fade ${showModal ? 'show' : ''}`} tabIndex="-1" role="dialog" style={{ display: showModal ? 'block' : 'none' }} aria-hidden={!showModal}>
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{details.title}</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={closeModal}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <img src={imageSrc} alt="Full Size" className="img-fluid" />
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={closeModal}>Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}